'use client';
import { createComponent } from "../internals/utils/index.js";
var ModalFooter = createComponent({
  name: 'ModalFooter'
});
export default ModalFooter;